// eslint-disable-next-line no-unused-vars
const canRequire = typeof __webpack_require__ === 'function';

module.exports =
{
    branding: 'logo', // 'heute', 'logo'
    theme: 'light', // 'dark', 'light'
    // Meta Tags für Facebook, Twitter
    meta: {
        // Seiten Title
        title: 'Reist durch die Länder der EU!',
        // Beschreibung
        description: 'Entdeckt viele krasse Fakten über die 27 Länder der Europäischen Union (EU)! Auf dieser Karte gibt´s Hymnen, Hauptstädte und hilfreiche Infos.',
        image: 'https://3d.zdf.de/kinder-eu-europaeische-union-laender-karte/img/Linkpreview.jpg',
        // URL
        url: 'https://3d.zdf.de/kinder-eu-europaeische-union-laender-karte/',
    },
    tracking: {
        storyName: 'Logo-Europa',
        storyID: 'logo_europa',
        // Tracking deaktivieren
        disabled: false,
    },
    babylon: {
        lightIntensity : 0,

        camera: {
            // Position, Ausrichtung und Kamera Bewegung
            // Kamera Position
            position: [-1.57,0.01,60], // alpha, beta, radius     .5 * Math.PI, .5 * Math.PI, 10
            moveFunction: 'move', // Wie die Kamera bewegt wird: 'move' Kamerafahrt, 'set' Springt zur Position
            target: [0,0,-3], // Wohin die Kamera blickt
            animationSpeed: 150, // Geschwindigkeit der Kamerabewegung

            // Begrenzungen
            //alphaLimits: [0, 0],
            betaLimits:[0.1,0.1],
            radiusLimits: [2, 100], // minCamRadius, maxCamRadius
            clipping: [.8, 10000.0],
            fov: 0.5,
            //invertRotation: true, // Kamera Steuerung umkehren für 360° Sphere Ansicht
            stopOnClick: true, // Kamera Animation stoppen, bei klick

            // Automatisches Drehen
            useAutoRotationBehavior: false,
            idleRotationSpeed: 0.05,

            // Steuerung
            panSensibility: 0, // 0 is deactivated
            wheelPrecision: 25.0, // 3.0 ist Standard
        },
    },
    audio: {
        enabled: true,
        // Dauerhafte Hintergrund Musik
        //background: canRequire && require('./assets/audio/News_Loop3.mp3'),
    },
    objects:
    [
        {
            // Name des Objekts zur Ansteuerung
            name: "zdfLogo",
            // GLB Dateiname im Ordner app/public/3d-models
            filename: "ZDF_Logo.glb",
            options: {
                //// BaseObject
                // true: Objekt anzeigen
                visible: false,
                // Skalierung: Objekt Größe ändern in allen Dimensionen
                scaling: [1, 1, -1],
                // Skalierung: Objekt Größe ändern (Alle Dimensionen gleich)
                //scale: 0.01,
                // Position
                position: [0, 0, 0],
                // Rotation
                rotation: [0.5 * Math.PI, 0, 0],
                // Rotation Quaternion, siehe https://doc.babylonjs.com/features/position,_rotation,_scaling#rotationquaternion
                //rotationQuaternion: [0.707, 0, 0, 0.707],
                // Transparenz (0 bis 1)
                //visibility: 0.25,
                // RGB-Farbe (diffuse) jeweils Werte 0 bis 255
                //diffuse: [255, 0, 0],
                // Zur Kamera ausrichten
                // 1: X-Achse, 2: Y-Achse, 4: Z-Achse, 7: Alle Achsen
                // 3: X & Y-Achse, 5: Z & X-Achse, 6: Z & Y-Achse
                // https://doc.babylonjs.com/typedoc/classes/babylon.abstractmesh#billboardmode
                billboardMode: 0,
                // Overlay Color zum hervorheben von Objekten
                //overlayColor: [250/255, 125/255, 25/255],
                // Rendering Group ID legt Objekte eine ebene nach vorne (Auch beim Hotspot)
                //renderingGroupId: 1

                //// MeshObject
                // Objekt mit Fade ein und ausblenden, wenn visible sich ändert
                fade: false,
                // Unter-Mesh-Objekte in der Datei
                // Name des Meshs wie im 3D Model
                ZDF_Logo: {
                    visible: false,
                    fade: false,
                    // Ist das Objekt anklickbar?
                    // Bei true wird ein Hotspot durch das Objekt nicht anklickbar, wenn verdeckt.
                    // Darum sollte bei transparenten Objekten ggf. pickable: false gesetzt werden.
                    pickable: true,
                    // Texture auf Objekt durchgehend verschieben. Zum Beispiel für Lava oder Wasser.
                    // Die zwei Werte geben die Verschiebung-Geschwindigkeit pro Achse an.
                    //animateTexture: [ -0.001, 0 ],

                    ZDF_Logo_2: {
                        visible: false,
                        fade: false,
                    }
                },

                //// BabylonObject
                // animation=true: startet die Animation im Objekt
                animation: false,

                // Nur initial, nicht per babylonState
                // OnClick Trigger
                // trigger: function () { }
            },
            // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
            callback: function (zdfLogo) // eslint-disable-line no-unused-vars
            {

            }
        },
        // Dies koennte ein zweites Objekt sein, das ihr ladet.
        // {
        //     name: "templateObject",
        //     filename: "templateObject.glb",
        //     options: {
        //         visible: false,
        //         position: [0, 0, 0],
        //         scaling: [.1, .1, .1],
        //         rotation: [0, 5.17, 0],
        //     },
        // },

        // {
        //     name: "ZDF_Logo2",
        //     filename: "ZDF_Logo.glb",
        //     options: {
        //         visible: false,
        //         position: [0, 0, -5],
        //         scaling: [1, 1, -1],
        //         rotation: [0.5 * Math.PI, 0, 0],
        //         children: {
        //             ZDF_Logo: {
        //                 visible: true,
        //             },
        //             ZDF_Logo_2: {
        //                 visible: true,
        //             },
        //         },
        //     },
        // },
        // {
        //     name: "Tschernobyl",
        //     filename: "Tschernobyl.glb", // https://3d.zdf.de/Tschernobyl/3d-models/Tschernobyl.glb
        //     options: {
        //         visible: false,
        //         position: [0, 0, 0],
        //         scaling: [.1, .1, .1],
        //         rotation: [0, 0, 0],
        //     },
        // },
         {
             name: "europa",
             filename: "europa.glb", // https://3d.zdf.de/coronavirus/3d-models/mdl_virus_016.glb
             options: {
                 visible: true,
                 position: [0, 0, 0],
                 scaling: [1, 1, -1],
                 rotation: [0, 0, 0],
                 pickable: false,

                 children:{
                    geo_sterne:{
                        visible: false,
                        pickable: false,
                        fade: true,
                    },

                    geo_eulabel:{
                        pickable: false,
                        visible: false
                    },

                    geo_laender_aktiviert:{
                        pickable: false,
                        visible: false,
                        fade: false,
                    },


                    // geo_info_portugal:{
                    //     visible: true,
                    //     renderingGroupId:3
                    // },

                    
                    //     visible: true,
                    //     position:[0,0,0],
                    //     geo_mehrinfos:{
                    //         visible: true
                    //     },

                    // },

                    // offset_mehrinfos:{
                    //     position:[0,0,0],
                    //     scaling: [1,1,1],
                    //     rotation: [0,0,0],
                    //     visible: true,
                    //     geo_mehrinfos:{
                    //         pickable: false,
                    //         //position:[0,0,0],
                    //         //scaling: [1,1,1],
                    //         //rotation: [0,0,0],
                    //     }
                    // },
                 }
             },
         },
    ],
    callback: function (europa) // eslint-disable-line no-unused-vars
    {

        let MAT_Belgien = this.scene.getNodeByName('geo_belgien').material;
        MAT_Belgien.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Deutschland = this.scene.getNodeByName('geo_deutschland').material;
        MAT_Deutschland.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Estland = this.scene.getNodeByName('geo_estland').material;
        MAT_Estland.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Frankreich = this.scene.getNodeByName('geo_frankreich').material;
        MAT_Frankreich.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Italien = this.scene.getNodeByName('geo_italien').material;
        MAT_Italien.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Irland = this.scene.getNodeByName('geo_irland').material;
        MAT_Irland.disableLighting = true;

        let MAT_Luxemburg = this.scene.getNodeByName('geo_luxemburg').material;
        MAT_Luxemburg.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Malta= this.scene.getNodeByName('geo_malta').material;
        MAT_Malta.disableLighting = true;

        let MAT_Niederlande = this.scene.getNodeByName('geo_niederlande').material;
        MAT_Niederlande.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Slowakei = this.scene.getNodeByName('geo_slowakei').material;
        MAT_Slowakei.disableLighting = true;
        MAT_Slowakei.separateCullingPass = true;


        let MAT_Europa = this.scene.getNodeByName('geo_eu').material;
        MAT_Europa.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Sterne = this.scene.getNodeByName('geo_sterne').material;
        MAT_Sterne.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Pfeil_links = this.scene.getNodeByName('geo_info_italien').material;
        MAT_Pfeil_links.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Pfeil_rechts = this.scene.getNodeByName('geo_info_luxemburg').material;
        MAT_Pfeil_rechts.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;

        let MAT_Laender_Aktiviert= this.scene.getNodeByName('geo_laender_aktiviert').material;
        MAT_Laender_Aktiviert.disableLighting = true;
        //MAT_Deutschland.separateCullingPass = true;



    },

};
